const apiUrl = {
  EXPERT_PAYMENT_INFO: "/api/expert-payment-info/",
  ORDER_PAYMENT: "/api/payment-order/",
  MEMBERSHIP_API: "/api/membership-list",
  TRANSACTION_HISTORY: "/api/transaction-history",
  GROUP_DETAIL: "/api/get-group-details/",
  PATCH_TRADE_DETAIL: "/api/trade/trade-patch",
  DELETE_TRADE_DETAIL: "/api/trade/delete-trade/",
  WATCHLIST_LISTING_API: "/api/trade/watchlist-detail/",
  WATCHLIST_SEARCH_API: "/api/trade/watchlist-search/",
  WATCHLIST_ADD_ITEMS: "/api/trade/watchlist-detail/",
  GET_LIVE_PRICE_API: "api/trade/update-live-price/",
  GET_TRADE_DURATION_LIST: "api/trade/duration-list",
  GET_DURATION_LIST: "/api/trade/duration-list/",

  // real trade api end points
  ENTRY_TRADE: "entry-order",
  EXIT_ORDER: "exit-order",
  ORDER_DETAIL: "details",
  USER_DETAIL: "userdetails",
  ORDERS: "orders",
  TRADE_DETAIL: "orders",
  TRADE_ACTIONS: "allowed-actions",
  ORDER_COUNT: "ordercount",
  INTEGRATION_SMALL_CASE_IMPORT: "integration/smallcase/import",
  PORTFOLIO_USER_DRTAIL: "portfolio/userdetails",
  GET_PORT_FOLIO: "portfolio",
  COPY_PORTFOLIO: "portfolio/copysecurities",
  PATCH_COPY_PORTFOLIO: "portfolio/basketdetails",
  MAKE_PUBLIC_PORTFOLIO: "portfolio/publicsecurities",
  FETCH_FUNDS: "fetch-funds",

  // Admin Panel Url
  ACCOUNT_DETAIL_VERIFICATION_LIST: "/api/expert-payment-info-list/",
  ADMIN_USER_APIS_LIST: "/admin-panel/user-list/",
  ADMIN_PANEL_APIS: "/admin-panel/user-detail/",
  ADMIN_PANEL_VIDEOS_PLAYLISTS: "/admin-panel/videos-playlists/",
  ACCOUNT_DELETE_URL: "/api/delete-account-info/",

  // Video Course
  VIDEO_DURATION_LIST: "/video/duration-list/",
  VIDEO_LANGUAGE_LIST: "/video/language-list/",
  VIDEO_LIST_API: "/video/video-list/",
  PLAYLIST_LIST_API: "/video/playlists/",
  UPLOAD_VIDEO_ASSETS: "/video/video-assets",
  PLAYLIST_SEARCH: "/video/playlist-search/",
  VIDEO_DETAIL_API: "/video/video-detail",
  PLAYLIST_DETAIL_API: "/video/playlist-detail/",
  PLAYLIST_VIDEOS_API: "/video/playlist-videos/",
  SUGGESTED_VIDEOS_API: "/video/suggested-videos/",
  RESUBMIT_VIDEO_OR_PLAYLIST: "/video/resubmit-detail/",
  VIDEO_ORDER: "/video/order-detail/",
  TRENDING_VIDEOS: "/video/trending-videos/",
  CAPTURE_VIEWS: "/video/capture-views/",
  COMMENT_LIST: "/video/comment-list/",
  COMMENT_DETAIL: "/video/comment-detail/",
  REPLY_COMMENT_LIST: "/video/reply-list/",
  REPLY_COMMENT_DETAIL: "/video/reply-comment/",
  VIDEO_TRANSACTION_HISTORY: "/video/transaction-history/",
  VIDEO_MY_SUBSCRIPTIONS: "/video/my-subscriptions/",

  //security page
  TIME_SERIES_DATA_API: "/api/trade/time-series-price/",
  SECURITY_OTHER_DATA: "/api/trade/security-other-data/",
  SECURITY_REVENUE_PROFITABILITY: "/api/trade/revenue-profitability",
  SECURITY_ASSETS_LIABILITIES: "/api/trade/assets-liabilities",
  SECURITY_CASH_FLOW: "/api/trade/cash-flow",
  SECURITY_NEWS: "/api/trade/security-news/",
  NEWS_DETIAL: "/api/trade/news-detail/",

  // search
  PROFILE_SEARCH: "/search/profile/",
  SECURITY_SEARCH: "/search/security/",
  GROUP_SEARCH: "/search/group/",

  //profile
  PROFILE_TRADE_APIS: "/api/trade/profile-trade-list",
  PROFILE_DETAIL_KPIS: "/api/trade/user-kpis/",
  SEND_VERIFICATION_OTP: "/api/profile/send-otp/",
  VERIFY_OTP: "/api/profile/verify-profile-otp/",
  DELETE_PROFILE: "/api/delete-account/",
  MERGE_USER_PROFILE: "/api/merge-user-profile/",

  //Trading Apis
  PAPER_TRADING_MARGIN_API: "/api/trade/balance-summary/",
  PAPER_TRADING_TRADES: "/api/trade/trading-trades/",

  //search
  USER_RECENT_SEARCH: "/api/trade/recent-search/",
  // Sebi Registration
  SEBI_REGISTRATION_API: "/api/sebi-registration/",
  GET_SEBI_REGISTRATION_DETAILS: "/api/sebi-registration-details/",
  UPDATE_SEBI_REGISTRATION_DETAILS: "/api/update-sebi-registration",

  VIEW_CONTACT_DETAIL: "/api/view-contact-details/",
  FREE_WEBINAR_REGISTER: "/trending/free-webinar-register/",
  SUBSCRIBE_FOR_FREE: "/api/group-free-trial/",
  EXPERTS_LIST: "api/portfolio-users/",

  CREATE_PORTFOLIO_PAYMENT: "/api/create-portfolio-payment/",
  UPDATE_PORTFOLIO_PAYMENT: "/api/update-portfolio-payment/",

  UPLOAD_RESEARCH_REPORT: "/api/trade/create-stock-report/",
  GET_RESEARCH_REPORT: "/api/trade/get-stock-report/",
  CREATE_REPORT_PAYMENT: "/api/trade/create-report-payment/",
  UPDATE_REPORT_PAYMENT: "/api/trade/stock-report-webhook/",

  CREATE_POLL: "/trending/create-poll/",
  GET_POLL_LIST: "/trending/get-all-poll/",
  POST_POLL_ANSWER: "/trending/vote/",

  DOWNLOADED_REPORTS: "/api/trade/my-reports/",

  //gamification
  GAMIFICATION_DATA: "/api/coins-trending-data/",
  GET_DAILY_TASK_DATA: "/api/daily-task/detail",
  GET_REDEEM_COIN_DATA: "/api/redeem-coin-utils",
  GET_PREMIUN_TRADE_LIST: "/api/trade/all-premium-trade-list",
  UNLOCK_TRADE: "/api/trade/unlock-premium-trades",
  GET_STREAK_DETAIL: "/api/user-streak-detail",
  POST_SHARE_TRADE: "api/trade/share-trade ",

  ADD_AUTO_GENERATE_REPORT: "/api/trade/report/pdf/",
  GET_QUESTION_LIST: "/master/questions_list/",
  GET_ALL_QUESTION_LIST: "/master/all_questions/",
  POST_ANSWERS: "/master/answers",

  GET_DOWNLOAD_TRADE_LIST: "api/trade/export_trade_list",
  COPY_EXPERT_TRADE_LIST: "/api/trade/all-trade-list/794/1/null/null/null/",
  GET_PREVIOUS_REQUEST_LIST: "/api/trade/export/list",
  GENERATE_REPORT: "api/trade/generate_trade_export",

  SAVE_REPORT: "/api/trade/save_report/",

  //telegram integration
  SAVE_TG_INFO: "/api/save/telegram/info",
  SEND_LOGIN_CODE: "/api/send/telegram/login_code",
  VERIFY_LOGIN_CODE: "/api/verify/telegram/login_code",
  CHECK_IF_TG_EXIST: "/api/telegram/verification/check",
  TG_MSG_TYPE_LIST: "/master/telegram/messages/types",
  TG_CHANNEL_LIST: "/api/telegram/channels/list",
};
export default apiUrl;
